import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ModalDialog from '../ModalDialog';
import { Box, CircularProgress, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { CancelPresentationRounded } from '@mui/icons-material';
import styles from './styles';
import { USER_BUG_PROGRESS_LEVEL } from '../../../utils/constants';
import { updateBugReport } from '../../../store/actions/userBugs';

const BugReportUpdateDialog = ({
  isOpen,
  onCloseClick,
  data
}) => {
  const classes = styles();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(data?.progress);
  const [comment, setComment] = useState((data?.progress === '2' && data?.comment) || '');

  const onDialogCloseClick = () => {
    onCloseClick();
  };

  const getModalTitle = () => {
    return (
            <>
                <Grid container alignItems="center" justifyContent="space-between">
                    <Grid item>
                        {'Bug Report Progress Update'}
                    </Grid>
                    <Grid item>
                        <IconButton
                            onClick={onCloseClick}
                        >
                            <CancelPresentationRounded fontSize='large' />
                        </IconButton>
                    </Grid>
                </Grid>
            </>
    );
  };

  const createDialogButtons = () => [
    {
      text: 'Submit',
      placeholder: 'Submit',
      'aria-label': 'Submit',
      onClick: () => {
        setLoading(true);
        const body = {
          query: {
            _id: data?._id
          },
          input: {
            progress,
            comment
          }
        };
        if (progress !== '2') {
          body.input.comment = '';
        }
        dispatch(updateBugReport(body, () => {
          setLoading(false);
          onCloseClick();
        }));
      },
      disabled: loading
    },
  ];

  return (
    <ModalDialog
      title={getModalTitle()}
      isOpen={isOpen}
      onClose={onDialogCloseClick}
      buttons={createDialogButtons()}
      maxWidth={'sm'}
    >
      {loading
        ? (
          <Grid className={classes.uploadingBugReportLoader}>
            <CircularProgress />
          </Grid>
          )
        : (
          <Grid sx={{ padding: 4 }}>
            <Box sx={{ mb: 3 }}>
              <Typography sx={{ fontWeight: 'bold', fontSize: '16px' }} gutterBottom>
                Issue: <span style={{ fontWeight: 'normal', fontSize: '17px' }}>
                &quot;{data?.issue}&quot;
                </span>
              </Typography>
            </Box>
            <Box sx={{ mb: 3, display: 'flex', alignItems: 'center' }}>
              <Typography sx={{ fontWeight: 'bold', fontSize: '16px', mr: 2 }} gutterBottom>
                Progress:
              </Typography>
              <FormControl
                variant="filled"
                className={classes.inputField}
              >
                <InputLabel id={'progress-label'}>Select</InputLabel>
                <Select
                  labelId={'progress-select'}
                  id={'progress-select'}
                  value={progress}
                  onChange={(e) => setProgress(e.target.value)}
                  disableUnderline
                  sx={{
                    fontSize: '16px',
                    '& .MuiMenuItem-root': {
                      fontSize: '16px',
                    },
                  }}
                >
                  {Object.keys(USER_BUG_PROGRESS_LEVEL).map((item, idItem) => (
                    <MenuItem key={`item_${idItem}`} value={item}>
                      {USER_BUG_PROGRESS_LEVEL[item]}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            {progress === '2' && (
              <Box>
                <Typography sx={{ fontWeight: 'bold', fontSize: '16px', mr: 2 }} gutterBottom>
                  Comment:
                </Typography>
                <TextField
                  multiline
                  fullWidth
                  minRows={2}
                  value={comment}
                  placeholder='Add a comment'
                  onChange={(e) => setComment(e.target.value)}
                />
              </Box>
            )}
          </Grid>
          )}
    </ModalDialog>
  );
};

BugReportUpdateDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired
};

export default BugReportUpdateDialog;
